







































import {
  defineComponent, ref, inject, computed, watch,
} from '@nuxtjs/composition-api';
import { SfSection, SfCheckbox } from '@storefront-ui/vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';

export default defineComponent({
  components: {
    SfSection,
    SfCheckbox,
    SkeletonLoader,
  },
  props: {
    filterCode: {
      type: String,
      default: 'att_climbing_options',
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const {
      filters, isFilterSelected, selectFilter, doApplyFilters,
    }: any = inject('UseFiltersProvider');
    const filter = ref();
    const selected = computed(() => ((id: string, optVal: string) => isFilterSelected(id, optVal)));

    watch(filters, () => {
      filter.value = filters.value.find((f) => f.attribute_code === props.filterCode) || { label: '', options: [] };
    }, { immediate: true });

    return {
      selectFilter,
      doApplyFilters,
      filter,
      selected,
    };
  },
});
